<template>
    <div class="mt15">
        <div class="order_main_btn text_center">
            <el-button type="primary" @click="submitForm()">저장</el-button>
            <el-button type="info" @click="$router.back()">목록</el-button>
            <change-complete-component v-if="checkStatusConfirm()"
                :orderKey="orderData.orderKey"
                :status="125"
            ></change-complete-component>
            <div class="order_btn" v-else-if="checkStatus()">
                <el-button type="primary" @click="openReasonModal('refundSuccess')">
                    환불요청 승인
                </el-button>
                <el-button type="danger" @click="openReasonModal('refundCancel')">
                    환불요청 거절
                </el-button>

            </div>

        </div>
    </div>
</template>

<script>
import ChangeCompleteComponent from "@/components/order/ChangeCompleteComponent.vue";

export default {
    name: "RefundSaveLayout",
    mixins: [],
    components: {ChangeCompleteComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {
        runWrite: {
            default: () => {
            }, type: Function
        },
        orderKey: {default:0},
        orderData: {default: () => {}},
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        checkStatusConfirm(){
            let status = this.orderData.refundStatus
            return status == 1  // 환불중
        },
        checkStatus(){
            let status = this.orderData.refundStatus
            return status == 0 // 환불요청
        },
        submitForm() {
            this.runWrite();
        },
        openReasonModal(type) {
            let orderKey = this.orderData.orderKey.toString();
            this.$modal.show('order-reason-modal',{type: type, key : orderKey})
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
